"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('underscore'),
  chain = _require.chain,
  isString = _require.isString;
var languages = require('src/utils/languages');
var LanguagePicker = /*#__PURE__*/function () {
  LanguagePicker.$inject = ["EventEmitter"];
  /* @ngInject */
  function LanguagePicker(EventEmitter) {
    _classCallCheck(this, LanguagePicker);
    this.EventEmitter = EventEmitter;
    this.languages = languages.getAllLanguages();
    var languageNames = languages.getAllNames();
    var self = this;
    this.searchConfig = {
      minimumInputLength: 2,
      placeholder: 'Select a language',
      initSelection: function initSelection(element, cb) {
        cb(self.model);
      },
      query: function query(_query) {
        var currentCode = self.serialize();
        var queryTerm = _query.term.toLowerCase();
        var disabledLangs = chain(self.disabledLangs).without(currentCode).map(languages.getName).value();
        var results = chain(languageNames).filter(function (name) {
          var startsWithQuery = name.toLowerCase().startsWith(queryTerm);
          var isNotDisabled = !disabledLangs.includes(name);
          return startsWithQuery && isNotDisabled;
        }).uniq().map(function (name) {
          var code = languages.getCode(name);
          return {
            id: code,
            text: name
          };
        }).value();
        _query.callback({
          results: results
        });
      }
    };
  }
  return _createClass(LanguagePicker, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.modalRegisterSerialize(this.EventEmitter({
        serialize: function serialize() {
          return _this.serialize();
        }
      }));
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (changes.model) {
        var code = changes.model.currentValue;
        this.model = {
          id: code,
          text: languages.getName(code)
        };
      }
    }
  }, {
    key: "update",
    value: function update(oldVal) {
      var newVal = this.serialize();
      if (newVal !== oldVal) {
        this.onChange(this.EventEmitter({
          model: newVal
        }));
      }
      if (isString(newVal)) {
        this.model = {
          id: newVal,
          text: languages.getName(newVal)
        };
      }
    }
  }, {
    key: "serialize",
    value: function serialize() {
      // select2 saves {id, text} instead
      return typeof this.model === 'string' ? this.model : this.model.id;
    }
  }]);
}();
module.exports = angular.module('backstage.components.common.language-picker', []).component('bsLanguagePicker', {
  templateUrl: '/src/angular/components/common/language-picker/language-picker.html',
  bindings: {
    model: '<',
    required: '<',
    disabledLangs: '<',
    onChange: '&',
    modalRegisterSerialize: '&'
  },
  controller: LanguagePicker
}).name;